// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
import { FieldsFactory } from '../Factory/FieldsFactory';
import { TradingWebhookGroup } from '../Groups/TradingWebhookGroup';
export class PFixTradingWebhookListResponse extends PFixMessage {
    get tradingWebhooks() {
        return this.getGroups(FieldsFactory.TRADING_WEBHOOK_GROUP, TradingWebhookGroup);
    }
    constructor(fieldSet) {
        super(Message.CODE_TRADING_WEBHOOK_LIST_RESPONSE, fieldSet);
    }
}
